import { z } from "zod";
import { ROLES } from "../constants/roles.js";
export const loginInput = z.object({
    email: z.string().email(),
    password: z.string().min(1).max(256),
});
export const sessionUser = z.object({
    id: z.number().int().positive(),
    email: z.string().email(),
    name: z.string(),
    role: z.enum(ROLES),
});
export const meOutput = z.object({
    user: sessionUser,
});
//# sourceMappingURL=auth.js.map